import React ,{ useState }from 'react'
import Accordion from 'react-bootstrap/Accordion';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ReviewOne from '../assets/images/review-1.svg'
import { Rating } from 'react-simple-star-rating'


function ProductInformation({productRow}) {  

  const [key, setKey] = useState('productDetails');
  return (
    <>
     <section className='product-information'>        
        <div className="product-information-wrap">
          <h2>Product Information</h2>
          <p>Find the perfect products for every chapter.</p>
          <Tabs
            defaultActiveKey="productDetails"
            id="uncontrolled-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab eventKey="productDetails" title="Product Details">
              {/* <h2>Product Information</h2> */}
              <div className="product-desc-content" dangerouslySetInnerHTML={{__html: productRow?.description}}></div>

            </Tab>
            <Tab eventKey="ingredients" title="Ingredients">
              <div className="ingredients-wrap">
                <div className="ingredients-desc-content" dangerouslySetInnerHTML={{__html: productRow?.ingredients}}></div>
                
                {productRow?.other_ingredients !== "" && (
                <div className='other-group'>
                  <h3>OTHER INGREDIENTS</h3>
                  <p>{productRow?.other_ingredients}</p>
                </div>
                )}
                {productRow?.does_not_contain !== "" && (
                <div className='other-group'>
                  <h3>{productRow?.title} DOES NOT CONTAIN</h3>
                  <p>{productRow?.does_not_contain}</p>
                </div>
                )}

                <div className='other-group'>
                  <h3>OTHER DETAILS</h3>
                  <p>UPC: {productRow?.UPC}</p>
                  <p>SKU: {productRow?.SKU}</p>
                </div>
              </div>
            </Tab>
            <Tab eventKey="directions" title="Directions">
              <div className='other-group'>
               <div className="directions-desc-content" dangerouslySetInnerHTML={{__html: productRow?.direction}}></div>
              </div>

            
            </Tab>
            <Tab eventKey="faqs" title="FAQ’s">
              <div className='faqs-wrap'>
                
              {productRow?.faqs?.length > 0 && (
                <Accordion defaultActiveKey="0">
                  
                  {productRow?.faqs?.map((faq, indexFaq) => (
                    <Accordion.Item eventKey={indexFaq.toString()} key={faq.id}>
                      <Accordion.Header>
                        <span>{indexFaq + 1 < 10 ? `0${indexFaq + 1}` : indexFaq + 1}</span>
                        {faq.question}
                      </Accordion.Header>
                      <Accordion.Body>
                        <p dangerouslySetInnerHTML={{__html: faq.answer }}/>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              )}

              </div>
            </Tab>
            <Tab eventKey="reviews" title="Reviews">
              {productRow?.reviews?.length > 0 && (
                <div className="reviews-wrap">
                  {productRow?.reviews?.map((review, indexReview) => (
                    <div className="reviews-item" key={"r"+indexReview}>
                      <div className="reviews-item-header">
                        <img src={ReviewOne} alt="" />
                        <h3>{review.name}</h3>
                        <span>{review.time_since}</span>
                      </div>
                      <div className="reviews-item-body">
                        <div className="product-review">
                        <Rating
                          readonly={true}
                          initialValue={review.rating} 
                          showTooltip 
                          tooltipDefaultText={`${review.rating}`} 
                        /> 
                        </div>
                        <p>{review.description}</p>
                        {(review?.images?.length > 0) && (
                          <img src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${review.images[0]}`} alt="" />
                        )}
                      </div>
                  </div>
                  ))}
                </div>
              )}

              
            </Tab>
          </Tabs>
        </div>
     </section>     
    </>
  )
}
export default ProductInformation 